module.exports = __webpack_public_path__ + "static/media/ding-ding-sound-effect.cf126e4c.mp3";